import { useEffect } from 'react';
import Nft from './Nft';
import Wrapper from '../assets/wrappers/NftContainer';
import { useSelector, useDispatch } from 'react-redux';
import Loading from './Loading';
import { getNftPaginate, setPage } from '../features/nft/nftSlice';
import PageButtonContainer from './PageButtonContainer';

const NftContainer = () => {
  const { paginate, isLoading } = useSelector((store) => store.nft);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNftPaginate());
  }, [paginate.page, dispatch]);

  if (isLoading) {
    return <Loading />;
  }

  if (paginate.docs.length === 0) {
    return (
      <Wrapper>
        <h2>No NFT to display...</h2>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <h5>
        {paginate.totalDocs} NFT{paginate.totalDocs > 1 && 's'} found
      </h5>
      <div className='jobs'>
        {paginate.docs.map((nft) => {
          return <Nft key={nft._id} {...nft} />;
        })}
      </div>
      {paginate.totalPages > 1 && (
        <PageButtonContainer
          totalPages={paginate.totalPages}
          page={paginate.page}
          setPage={setPage}
        />
      )}
    </Wrapper>
  );
};
export default NftContainer;
